const loaderStyle = {
  '.loadingOverlay': {
    position: 'fixed',
    display: 'none',
    width: '100%',
    height: '100%',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    backgroundColor: 'rgba(255,255,255,0.8)',
    zIndex: 999999,
  },
  '.loading': {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    msTransform: 'translate(-50%,-50%)',
  },
  '.loadingHeader': {
    marginLeft: '40px',
    fontSize: "'16px'",
    fontWeight: "'bold'",
    color: "'#333333'",
    marginBottom: "'14px'",
  },
};

export default loaderStyle;
